"use client";

import { usePathname } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { InfoAlert } from "./info-alert";

export function LegalEnglishNote() {
  const t = useTranslations("Legal");
  const englishOnlyNote = t("englishOnlyNote");
  const pathname = usePathname();

  if (!englishOnlyNote.length) {
    return null;
  }

  return (
    <div className="mb-6">
      <InfoAlert
        variant="info"
        message={englishOnlyNote}
        action={t("readInEnglish")}
        href={`/en${pathname}`}
      />
    </div>
  );
}
